import { render, staticRenderFns } from "./HistoryTabContent.vue?vue&type=template&id=d76edbae&"
import script from "./HistoryTabContent.vue?vue&type=script&lang=ts&"
export * from "./HistoryTabContent.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryTabContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSpacer,VTextField})
